import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-child-status',
  templateUrl: './child-status.component.html',
  styleUrls: ['./child-status.component.scss']
})
export class ChildStatusComponent {
  @Input() childStatus: any
}
